import HttpClient from "../../utils/http";
import { Merchant, Voucher } from "../../views/merchant/model/merchant_model";
import { 
  createMerchant as createMerchantEndpoint,
  getMerchants,
  createVouchers,
  getVouchers,
  assignVouchersToMerchant as assignVouchersToMerchantEndpoint,
  assignVouchersToUser as assignVouchersToUserEndpoint,
  redeemVoucher as redeemVoucherEndpoint,
  verifyVoucherCode as verifyVoucherCodeEndpoint,
  verifyOtp
} from "../constants/api_endpoints";

// API Request/Response interfaces
export interface CreateVoucherRequest {
  amount: number;
  count: number;
}

export interface CreateMerchantRequest {
  name: string;
  pincode: number;
  location: string;
  mobile_no: string;
  state: string;
}

export interface AssignVouchersRequest {
  merchant_id: string;
  number_of_vouchers: number;
}

export interface AssignVouchersResponse {
  assigned: number;
  vouchers: Voucher[];
}

export interface RedeemVoucherRequest {
  voucher_code: string;
  merchant_id: string;
}

export interface RedeemVoucherResponse {
  message: string;
  voucher: Voucher;
}

export interface AssignVoucherToUserRequest {
  user_id: number;
  number_of_vouchers: number;
  merchant_id?: string;
}

export interface AssignVoucherToUserResponse {
  assigned: number;
  vouchers: Voucher[];
}

export interface VerifyOtpRequest {
  voucher_code: string;
  merchant_id: string;
  otp: number;
}

export interface VerifyOtpResponse {
  message: string;
  success: boolean;
}

export interface VerifyVoucherRequest {
  voucher_code: string;
  merchant_id: string;
}

export interface VerifyVoucherResponse {
  message: string;
  success: boolean;
}

// Create Voucher API
export function createVoucher(data: CreateVoucherRequest): Promise<{ data: Voucher[] }> {
  return HttpClient.post(createVouchers, data);
}

// Create Merchant API
export function createMerchant(data: CreateMerchantRequest): Promise<{ data: Merchant }> {
  return HttpClient.post(createMerchantEndpoint, data);
}

// Get All Vouchers API
export function getAllVouchers(): Promise<{ data: { data: { list: Voucher[], total: number } } }> {
  return HttpClient.get(getVouchers);
}

// Get All Merchants API
export function getAllMerchants(): Promise<{ data: { data: { list: Merchant[], total: number } } }> {
  return HttpClient.get(getMerchants);
}

// Redeem Voucher API
export function redeemVoucher(data: RedeemVoucherRequest): Promise<{ data: RedeemVoucherResponse }> {
  return HttpClient.post(redeemVoucherEndpoint, data);
}

// Assign Vouchers to User API
export function assignVouchersToUser(data: AssignVoucherToUserRequest): Promise<{ data: AssignVoucherToUserResponse }> {
  return HttpClient.post(assignVouchersToUserEndpoint, data);
}

// Assign Vouchers to Merchant API
export function assignVouchersToMerchant(data: AssignVouchersRequest): Promise<{ data: AssignVouchersResponse }> {
  return HttpClient.post(assignVouchersToMerchantEndpoint, data);
}

// Verify Voucher Code API (sends OTP)
export function verifyVoucherCode(data: VerifyVoucherRequest): Promise<{ data: VerifyVoucherResponse }> {
  return HttpClient.post(redeemVoucherEndpoint, data);
}

// Verify OTP API
export function verifyOtpForVoucher(data: VerifyOtpRequest): Promise<{ data: VerifyOtpResponse }> {
  return HttpClient.post(verifyOtp, data);
}
